import styles from './BidModal.module.scss'
import BidButton from 'elements/BidButton/BidButton'

interface IMaxBidModalData {
  qty: number
  bid: number
  location: string
}

interface MaxBidModalProps {
  visible: boolean
  item: IMaxBidModalData
  onYes: () => void
  onNo: () => void
}

export const MaxBidModal = ({
  visible = false,
  item,
  onYes = () => {},
  onNo = () => {},
}: MaxBidModalProps) => {
  const { qty, bid, location } = item
  const title = qty > 1 ? 'Multiple Quantity Max Bid' : 'Max Bid Confirmation'
  const confirmLabel = qty > 1 ? `Bid on ${qty}` : 'Yes'
  const denyLabel = qty > 1 ? 'Cancel' : 'No'
  const total = `$${(bid * (qty || 1)).toFixed(2)}`

  const handleYes = (e: any) => {
    e.stopPropagation()
    onYes()
  }

  const handleNo = (e: any) => {
    e.stopPropagation()
    onNo()
  }

  return (
    <div
      className={`transition-opacity duration-200 fixed top-0 left-0 flex justify-center items-center w-full h-screen p-4 xl:pl-50 bg-black/30  ${
        visible ? ` opacity-100 z-50` : ` opacity-0 ${styles.hide_modal}`
      }`}
      onClick={(e: any) => {
        e.stopPropagation()
      }}
    >
      <div className={`${styles.modal} bg-white rounded-lg`}>
        <div className="py-2 px-6 rounded-t-lg bg-bidfta-blue-light text-white font-bold text-sm">
          {title}
        </div>

        <div className="pt-4 pb-2 px-6 text-xs text-center">
          {qty > 1 ? (
            <>
              <p className="text-base uppercase font-bold">
                You are bidding on{' '}
                <span className="text-bidfta-blue-light">{qty}</span> items
              </p>
              <p className="text-base font-bold">
                Your max bid total will be {total}
              </p>
              <div className="my-3">
                <p className="text-sm font-bold">{`(${bid} x ${qty}) = ${total}!`}</p>
                <p className="text-bidfta-gray-borderdark">
                  (Max Bid x Quantity) = Max Bid Total
                </p>
              </div>
              <p>
                Pickup location: <span className="font-bold">{location}</span>
              </p>
              <p>Are you sure?</p>
            </>
          ) : (
            <div className="py-2">
              <p>Your max bid for this item is {total}!</p>

              <p className="mt-1">
                Pickup location: <span className="font-bold">{location}</span>
              </p>

              <p className="mt-1">Are you sure?</p>
            </div>
          )}
        </div>

        <div className="flex justify-center pt-2 pb-4 px-6 text-center">
          <div className="mx-1 w-20">
            <BidButton
              label={confirmLabel}
              theme="green"
              callBack={handleYes}
              width="full"
              size="xs"
            />
          </div>
          <div className="mx-1 w-20">
            <BidButton
              label={denyLabel}
              theme="red"
              callBack={handleNo}
              width="full"
              size="xs"
              fullHeight
            />
          </div>
        </div>
      </div>
    </div>
  )
}
